module.exports = __webpack_public_path__ + "img/orderIcon.0deff291.png";